import Keycloak from 'keycloak-js';

console.log(process.env.NODE_ENV);

const options = {
  url: process.env.REACT_APP_KEYCLOAK_URL,
  clientId: process.env.REACT_APP_CLIENT_ID,
  realm: process.env.REACT_APP_REALM
};

const keycloak = new Keycloak(options);

let authenticated;
let store = null;

/**
 * Initializes Keycloak, then run callback.
 * This will prompt you to login.
 *
 * @param onAuthenticatedCallback
 */
async function init(onInitCallback) {
  // Detecta se já voltamos de um callback OAuth (URL tem ?code= ou ?error=)
  // Se sim e a autenticação falhar, não redireciona de novo — quebra o loop
  const urlParams = new URLSearchParams(window.location.search);
  const isOAuthCallback =
    urlParams.has('code') ||
    urlParams.has('error') ||
    urlParams.has('session_state');

  try {
    /*
    console.log('[KC DEBUG] hash:', window.location.hash);
    console.log(
      '[KC DEBUG] sessionStorage:',
      JSON.stringify(Object.fromEntries(Object.entries(sessionStorage)))
    );
    */

    authenticated = await keycloak.init({
      onLoad: "check-sso",
      checkLoginIframe: false,
      useNonce: window.isSecureContext, 
    });

    if (!authenticated) {
      keycloak.login();
      return new Promise(() => {}); 
    }

    const userInfo = await keycloak
      .loadUserInfo()
      .then(user => {
        return user;
      })
      .catch(e => console.log(e));

    const user = {
      authenticated: keycloak.authenticated,
      username: keycloak.idTokenParsed.preferred_username,
      token: keycloak.token,
      refreshToken: keycloak.refreshToken,
      email: userInfo ? userInfo.email : undefined,
      name: userInfo ? userInfo.name : undefined,
      fullName: userInfo ? userInfo.name : undefined,
      id: userInfo ? userInfo.id : undefined,
      roles: keycloak.resourceAccess?.account?.roles ?? []
    };

    localStorage.setItem("authUser", JSON.stringify(user));

    return onInitCallback;
  } catch (error) {
    console.error("Keycloak init failed");
    console.error(error);
    throw error;
  }
}

/**
 * Initializes store with Keycloak user data
 */
async function initStore(storeInstance) {
  try {
    store = storeInstance;
    store.initOauth(keycloak, false);

    // Show alert if user is not authenticated
    if (!authenticated) {
      alert("not authenticated");
    }
  } catch (error) {
    console.error("Keycloak init failed");
    console.error(error);
  }
}

/**
 * Logout user
 */
function logout(url) {
  keycloak.logout({ redirectUri: url });
}

/**
 * Refreshes token
 */
async function refreshToken() {
  try {
    await keycloak.updateToken(480);
    return keycloak;
  } catch (error) {
    console.error('Failed to refresh token');
    console.error(error);
  }
}

const KeycloakService = {
  CallInit: init,
  CallInitStore: initStore,
  CallLogout: logout,
  CallTokenRefresh: refreshToken
};

export default KeycloakService;